import { render, staticRenderFns } from "./StudentsDraw.vue?vue&type=template&id=f34aa746&scoped=true&"
import script from "./StudentsDraw.vue?vue&type=script&lang=js&"
export * from "./StudentsDraw.vue?vue&type=script&lang=js&"
import style0 from "./StudentsDraw.vue?vue&type=style&index=0&id=f34aa746&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34aa746",
  null
  
)

export default component.exports